'use client';
import { StyledInteractiveBanner } from '@/src/components/common/eco/sections/banner/banner.style.js';
import React from 'react';
import { SlideOne as SlideItem } from '@/src/components/common/eco/sections/banner/slide-one.jsx';
import useContainerOffset from '@/src/hooks/useContainerOffset.jsx';

const SliderMain = ({ containerGap, data }) => {
	// Refs for main home-slider and navigation home-slider
	let offset = useContainerOffset('.container');

	// demo length
	return (
		<StyledInteractiveBanner
			id="home"
			offset={offset}
			containerGap={containerGap}
			className={'home-banner'}>
			<div
				className="main-banner-wrapper-stick">
				{data?.posts?.list && data?.posts?.list?.length > 0 && (
					data?.posts?.list.map((e, index) => {
						const isVideo = e?.images?.find(f => f?.is_video === 'on');
						const isBanner = e?.images?.find(f => f?.banner === 'on');

						const commonProps = {
							topTitle: e?.data?.subtitle,
							title: e?.data?.subtitle,
							subTitle: e?.data?.short_desc || '',
							description: e?.data?.description || '',
							buttonLabel: '',
							buttonLink: '',
							buttonTarget: 'self',
						};

						return (
							<SlideItem
								{...commonProps}
								video={!!isVideo}
								bannerLarge={
									isVideo
										? isVideo?.short_desc
										: isBanner?.full_path
								}
								bannerSmall={
									isVideo
										? isVideo?.short_desc
										: isBanner?.full_path
								}
								classname={!isVideo ? 'anim-char' : undefined}
								total={!isVideo ? list.length : undefined}
							/>
						);
					})
				)}
			</div>
		</StyledInteractiveBanner>
	);
};


export default React.memo(SliderMain);
